var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 106,
    viewBox: "0 0 391 106",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4577_213584",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 373,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88647 42.433L43.9419 9.00036L379.907 9.30011V63.8574L345.861 96.0981L9.88647 96.9973V42.433Z",
    fill: "black",
    stroke: "#9940C3",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4577_213584)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.96821 -2.9236H180.316V-4.04688H-1.96821V-2.9236ZM-1.96821 98.1741H180.316V97.0508H-1.96821V98.1741ZM180.316 17.2952H-1.96826V16.1719H180.316V17.2952ZM-1.96821 118.389H180.316V117.266H-1.96821V118.389ZM180.316 57.7327H-1.96821V56.6094H180.316V57.7327ZM-1.96821 158.83H180.316V157.707H-1.96821V158.83ZM180.316 77.9514H-1.96826V76.8281H180.316V77.9514ZM-1.96821 179.045H180.316V177.922H-1.96821V179.045ZM180.316 37.5139H-1.96826V36.3906H180.316V37.5139ZM-1.96826 138.608H180.316V137.484H-1.96826V138.608Z",
    fill: "url(#paint0_linear_4577_213584)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72079 179.047L8.72079 -2.92413H7.59558L7.59558 179.047H8.72079ZM109.989 179.047L109.989 -2.92413H108.864L108.864 179.047H109.989ZM28.9745 -2.92413L28.9745 179.047H27.8493L27.8493 -2.92413H28.9745ZM130.243 179.047V-2.92413H129.118V179.047H130.243ZM69.4819 -2.92413L69.4819 179.047H68.3567L68.3567 -2.92413H69.4819ZM170.751 179.047V-2.92413H169.625V179.047H170.751ZM89.7356 -2.92413L89.7356 179.047H88.6104L88.6104 -2.92413H89.7356ZM191.004 179.047V-2.92412H189.879V179.047H191.004ZM49.2282 -2.92413L49.2282 179.047H48.103L48.103 -2.92413H49.2282ZM150.497 179.047V-2.92413H149.372V179.047H150.497Z",
    fill: "url(#paint1_linear_4577_213584)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.909 1.90453H227.625V0.78125H409.909V1.90453ZM409.909 103.002H227.625V101.879H409.909V103.002ZM227.625 22.1233H409.909V21H227.625V22.1233ZM409.909 123.217H227.625V122.094H409.909V123.217ZM227.625 62.5608H409.909V61.4375H227.625V62.5608ZM409.909 163.658H227.625V162.535H409.909V163.658ZM227.625 82.7795H409.909V81.6562H227.625V82.7795ZM409.909 183.873H227.625V182.75H409.909V183.873ZM227.625 42.342H409.909V41.2188H227.625V42.342ZM409.909 143.436H227.625V142.312H409.909V143.436Z",
    fill: "url(#paint2_linear_4577_213584)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.22 183.875V1.90399H400.345V183.875H399.22ZM297.951 183.875V1.90399H299.077V183.875H297.951ZM378.966 1.90399V183.875H380.091V1.90399H378.966ZM277.698 183.875V1.90399H278.823V183.875H277.698ZM338.459 1.90399V183.875H339.584V1.90399H338.459ZM237.19 183.875V1.90399H238.315V183.875H237.19ZM318.205 1.90399V183.875H319.33V1.90399H318.205ZM216.937 183.875V1.90399H218.062V183.875H216.937ZM358.713 1.90399V183.875H359.838V1.90399H358.713ZM257.444 183.875V1.90401H258.569V183.875H257.444Z",
    fill: "url(#paint3_linear_4577_213584)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4577_213584)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5205 10.4084L11.2986 43.0226V95.5893L346.503 94.69L379.701 63.2528V10.7082L44.5205 10.4084ZM382.113 64.2876L347.466 97.097L8.88647 98V42.0134L43.5335 8L382.113 8.301V64.2876Z",
    fill: "#A948D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4577_213584",
    x: 0.886475,
    y: 0,
    width: 389.227,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.737333 0 0 0 0 0.373333 0 0 0 0 0.933333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4577_213584"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4577_213584",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4577_213584",
    x1: -1.96826,
    y1: 98.7318,
    x2: 157.249,
    y2: 98.1683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4577_213584",
    x1: 8.15818,
    y1: 85.2536,
    x2: 191.567,
    y2: 85.2535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4577_213584",
    x1: 409.909,
    y1: 103.56,
    x2: 250.692,
    y2: 102.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4577_213584",
    x1: 399.783,
    y1: 90.0817,
    x2: 216.374,
    y2: 90.0816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFrame);
export default __webpack_public_path__ + "static/media/information-frame.8e8082ada0daf36f7dac006f09f53451.svg";
export { ForwardRef as ReactComponent };